<template>
	<UiDialog v-if="show">
		<UiElement :settings="dialog.appearance.body.settings">
			<div class="d-flex flex-column align-items-center justify-content-center">
				<UiText :settings="heading1" class="text-center" :content="translations?.maxProductsCount || '{maxProductsCount}'" />

				<UiButton
					:settings="button1"
					@touchstart="hideDialogMaxCount"
					:content="translations?.ok || '{ok}'"
				/>
			</div>
		</UiElement>
	</UiDialog>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useThemeStore } from '@/stores/useThemeStore';
import { useDialogStore } from '@/stores/useDialogStore';
import { useTranslationsStore } from '@/stores/useTranslationsStore';
import { useInheritedSettings } from '@/composables/useInheritedSettings';
import UiText from '@/components/UI/UiText.vue';
import UiDialog from '@/components/UI/UiDialog.vue';
import UiButton from '@/components/UI/UiButton.vue';
import UiElement from '@/components/UI/UiElement.vue';

const { hideDialogMaxCount } = useDialogStore();

defineProps({
	show: {
		type: Boolean,
		default: false,
	}
});

const themeStore = useThemeStore();
const translationsStore = useTranslationsStore();

const { theme } = storeToRefs(themeStore);
const { translations } = storeToRefs(translationsStore);

const dialog = computed(() => theme.value.pages.dialogMaxCount);

const heading1 = useInheritedSettings(computed(() => dialog.value?.elements.heading1));
const button1 = useInheritedSettings(computed(() => dialog.value?.elements.button1));
</script>